<template>
  <ul class="mt-3 text-xs text-black-50 pl-3">
    <li>At least 12 characters.</li>
    <li>At least one of each: uppercase letters, lowercase letters, numbers, symbols.</li>
    <li>No character may be repeated 3 or more times.</li>
    <li>No ordered numeric sequence of more than 2 characters is allowed (i.e. 123 or 321).</li>
    <li>No ordered or patterned sequence of adjacent characters of more than 3 characters (i.e. abcd, abab).</li>
  </ul>
</template>
<script>
export default {
  name: "PasswordComplexityList",
}
</script>